import React from 'react';
import ConsumoInterno from '../../../components/insumos/informes/ConsumoInterno';
import { PageWrapper } from '../../../components/common';

const ConsumoInternoPage: React.FC = () => {
  return (
    <PageWrapper>
      <ConsumoInterno />
    </PageWrapper>
  );
};

export default ConsumoInternoPage;
